




















































import Vue from "vue";
import { Util } from "@/util/util";
import { Config } from "@/model/config";
import { translate } from "@/filters";

export default Vue.extend({
  name: "ViewSelector",
  data() {
    return <
      {
        selectedEnvironment: string;
      }
    >{
      selectedEnvironment: ""
    };
  },
  props: {},
  mounted() {
    this.setCurrentEnvironment();
  },
  methods: {
    setCurrentEnvironment(): void {
      const config: Config = Util.getConfig();
      if (config.currentPagePath.includes(config.environments.webshop)) {
        this.selectedEnvironment = "shop";
      } else if (config.currentPagePath.includes(config.environments.bonusshop)) {
          this.selectedEnvironment = "bonusshop";
      } else {
          this.selectedEnvironment = "portal";
      }
    },
    goToEnvironment() {
      const config: Config = Util.getConfig();

      switch (this.selectedEnvironment) {
        case "shop":
          window.open(config.environments.webshop, "_self");
          break;
        case "portal":
          window.open(config.environments.portal, "_self");
          break;
        case "bonusshop":
          window.open(config.environments.bonusshop, "_self");
          break;
      }
    }
  }
});
